module.exports = function () {
  this.app.$on('submitRsvp', event => {
    let rsvpData = {
      token: event.isCorporate ? event.token : this.session.token,
      brandId: this.app.brand.id,
      guest: event.guest,
      legs: [ event.leg1, event.leg2 || null ],
      payment: event.payment,
      wheelchair: event.wheelChair,
      serviceDog: event.serviceDog,
      source: 'C',
      deviceType: 'ww',
      hudson: event.hudson,
      d2dPayment: true
    }

    if (event.isMtech) {
      rsvpData.quoteId = event.quoteId
      rsvpData.isMTech = event.isMtech
    }
    if (event.lyft) {
      rsvpData.lyft = true
    }
    if (event.discountCodeId) {
      rsvpData.discountCodeId = event.discountCodeId
      rsvpData.discountCodeAmount = event.discountCodeAmount
    }
    console.log('SUBMIT RSVP', rsvpData)
    this.sdk.post('/reservations', rsvpData, response => {
      if (!response.error) {
        this.app.$emit('submitRsvpSuccess', response)
      } else {
        this.app.$emit('submitRsvpFail', response)
      }
    }, '/1.1')
  })

  this.app.$on('submitCharterRsvp', param => {
    console.log('SUBMIT CHARTER RSVP', param)
    this.sdk.post('/reservations', param, response => {
      if (!response.error) {
        this.app.$emit('submitRsvpSuccess', response)
      } else {
        this.app.$emit('submitRsvpFail', response)
      }
    }, '/1.1')
  })
}



// WEBPACK FOOTER //
// ./src/events/submit-rsvp.js